import { createElement } from "react";
import IdeasRemote from "./IdeasRemote";
import { getBoardBySlug } from "src/pods/ideas/boardCatalog";

type IdeasRemoteContainerProps = {
  params: { ideaId?: string };
};

export default function IdeasRemoteContainer({ params }: IdeasRemoteContainerProps) {
  const selectedBoard = getBoardBySlug(params.ideaId);

  if (!selectedBoard) {
    return null;
  }

  return createElement(IdeasRemote, { selectedBoard });
}
